<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin() == true || $gate.isHRAdmin() == true">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>Employees | Master</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <div class="col-lg-12">
                    <div class="card card-danger card-outline collapsed-card">
                        <div class="card-header">
                            <div class="card-title">
                                Data Filters | -- | Total results now displayed:
                                {{ total_results }}
                            </div>
                            <div class="card-tools">
                                <!-- Collapse Button -->
                                <button
                                    type="button"
                                    class="btn btn-tool btn-danger"
                                    data-card-widget="collapse"
                                >
                                    <i class="fas fa-minus"></i> Show/Hide
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="col-lg-12 float-left">
                                <div class="row">
                                    <!-- <div class="col-sm-4" v-if='$gate.isZonalManager()'> -->

                                    <!--                            <div class="col-sm-4">-->
                                    <!--                                <div class="form-group">-->
                                    <!--                                    <span class="right badge badge-secondary">Item Category:</span>-->
                                    <!--                                    <select v-model="params.delivery_item_category" style="width: 100% !important" class="form-control">-->
                                    <!--                                        <option v-for="j in delivery_item_categories" :key="j.id" :value="j.id">-->
                                    <!--                                            {{ j.category }}-->
                                    <!--                                        </option>-->
                                    <!--                                        &lt;!&ndash; <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> &ndash;&gt;-->
                                    <!--                                    </select>-->
                                    <!--                                </div>-->
                                    <!--                            </div>-->

                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Company:</span
                                            >
                                            <v-select
                                                v-model="params.company"
                                                class="form-control"
                                                type="text"
                                                label="name"
                                                :options="companies"
                                                :reduce="
                                                    (companies) =>
                                                        companies.code
                                                "
                                                name="company"
                                                placeholder="Select Company"
                                                :value="
                                                    (companies) =>
                                                        companies.code
                                                "
                                            ></v-select>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Branch:</span
                                            >
                                            <v-select
                                                v-model="params.branch"
                                                class="form-control"
                                                type="text"
                                                label="branch"
                                                :options="branches"
                                                :reduce="
                                                    (branches) =>
                                                        branches.branch_code
                                                "
                                                name="branch"
                                                placeholder="Select Branch"
                                                :value="
                                                    (branches) =>
                                                        branches.branch_code
                                                "
                                            ></v-select>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Employee Name:</span
                                            >
                                            <input
                                                class="form-control"
                                                placeholder="Enter customer name"
                                                v-model="params.name"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Phone Number:</span
                                            >
                                            <input
                                                class="form-control"
                                                placeholder="Enter phone number"
                                                v-model="params.phone"
                                                type="number"
                                                min="1"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Results Per Page:</span
                                            >
                                            <input
                                                type="text"
                                                class="form-control"
                                                min="5"
                                                value="10"
                                                v-model="params.results"
                                                placeholder=" Enter No. of results"
                                                @input="getEmployees()"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Employee Code:</span
                                            >
                                            <input
                                                type="text"
                                                class="form-control"
                                                min="5"
                                                value="10"
                                                v-model="params.emp_code"
                                                placeholder=" Enter Employee Code"
                                                @input="getEmployees()"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >ERP Employee Code:</span
                                            >
                                            <input
                                                type="text"
                                                class="form-control"
                                                min="5"
                                                value="10"
                                                v-model="params.erp_emp_code"
                                                placeholder=" Enter ERP Emp Code"
                                                @input="getEmployees()"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >ERP SP Code:</span
                                            >
                                            <input
                                                type="text"
                                                class="form-control"
                                                min="5"
                                                value="10"
                                                v-model="params.sp_code"
                                                placeholder=" Enter ERP SP Code"
                                                @input="getEmployees()"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >BRAND:</span
                                            >
                                            <input
                                                type="text"
                                                class="form-control"
                                                min="5"
                                                value="10"
                                                v-model="params.brand"
                                                placeholder=" Enter Brand"
                                                @input="getEmployees()"
                                            />
                                        </div>
                                    </div>
                                    <!--                            <div class="col-sm-4">-->
                                    <!--                                <span class="right badge badge-secondary">POS ID:</span>-->
                                    <!--                                <div class="form-group"><input class="form-control" placeholder="Enter delivery commitment id" v-model="params.dc_id" type="number" min="1">-->
                                    <!--                                </div>-->
                                    <!--                            </div>-->
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <button
                                                class="btn btn-primary"
                                                style="width: 100% !important"
                                                @click="getEmployees()"
                                            >
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <button
                                                class="btn btn-success"
                                                style="width: 100% !important"
                                                @click="excel"
                                            >
                                                Export
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <button
                                                class="btn btn-danger"
                                                style="width: 100% !important"
                                                @click="reset"
                                            >
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br /><br />
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-lg-3 col-6">
                            <!-- small box -->
                            <div class="small-box bg-danger">
                                <div class="inner">
                                    <h3>{{ total_employees }}</h3>
                                    <p>Total</p>
                                </div>
                                <div class="icon">
                                    <i class="ion ion-person-add"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-6">
                            <!-- small box -->
                            <div class="small-box bg-danger">
                                <div class="inner">
                                    <h3>{{ total_oxy }}</h3>
                                    <p>Oxygen Digital Shop</p>
                                </div>
                                <div class="icon">
                                    <i class="ion ion-person-add"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-6">
                            <!-- small box -->
                            <div class="small-box bg-danger">
                                <div class="inner">
                                    <h3>{{ total_ssq }}</h3>
                                    <p>SSquared Technologies</p>
                                </div>
                                <div class="icon">
                                    <i class="ion ion-person-add"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-6">
                            <!-- small box -->
                            <div class="small-box bg-danger">
                                <div class="inner">
                                    <h3>{{ total_ozn }}</h3>
                                    <p>Ozone</p>
                                </div>
                                <div class="icon">
                                    <i class="ion ion-person-add"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- main row for all icons  -->
                <div class="col-md-12 center center-block" align="center">
                    <div class="card card-danger card-outline">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-sm-4">
                                    <button
                                        @click="Eexport(true)"
                                        class="btn btn-secondary float-left"
                                    >
                                        Template
                                    </button>
                                </div>
                                <div class="col-sm-4">
                                    <button
                                        @click="Eexport(false)"
                                        class="btn btn-info"
                                    >
                                        Export
                                    </button>
                                    &nbsp;
                                    <!--                <button @click="uploadPrompt" class="btn btn-primary">Import</button>-->
                                </div>
                                <div class="col-sm-4">
                                    <button
                                        @click="syncSalesmen"
                                        class="btn btn-danger float-right"
                                    >
                                        Sync Employees
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body overflow-auto">
                            <div class="col-md-12 float-left">
                                <div class="row">
                                    <div class="col-sm-4"></div>
                                </div>
                            </div>

                            <img v-if="employees == ''" src="" />

                            <!-- content here -->
                            <datatable
                                style="margin-top: 1%"
                                :columns="columns"
                                v-else
                            >
                                <tbody>
                                    <tr v-for="man in employees" :key="man.id">
                                        <td>{{ man.emp_code }}</td>
                                        <td>{{ man.erp_emp_code }}</td>
                                        <td>{{ man.sp_code }}</td>
                                        <td>{{ man.name }}</td>
                                        <td>
                                            {{ man.company_id }}-{{
                                                man.branch_code
                                            }}-{{ man.branch_name }}
                                        </td>
                                        <td>{{ man.phone }}</td>
                                        <td>
                                            <span
                                                :class="
                                                    man.status == 'Permanent'
                                                        ? 'badge-secondary badge'
                                                        : 'badge-danger badge'
                                                "
                                                >{{ man.status }}</span
                                            >
                                        </td>
                                        <!--                        <td><span class="badge badge-secondary">{{man.status}}</span></td>-->
                                        <td>
                                            <button
                                                class="btn btn-danger"
                                                @click="view(man)"
                                            >
                                                <i class="fa fa-eye"></i> Peek
                                            </button>
                                            &nbsp;
                                            <button
                                                class="btn btn-danger"
                                                @click="
                                                    viewEmployeeProfile(man)
                                                "
                                            >
                                                <i class="fa fa-search"></i>
                                                Profile
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </datatable>
                        </div>
                        <div class="card-footer">
                            <pagination
                                :pagination="pagination"
                                @prev="getEmployees(pagination.prevPageUrl)"
                                @next="getEmployees(pagination.nextPageUrl)"
                            ></pagination>
                        </div>
                    </div>
                </div>
                <!-- row end -->
            </section>
            <!-- /.content -->

            <div class="modal" tabindex="-1" role="dialog" id="uploadModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Branch Details</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div
                                :class="[
                                    'form-group',
                                    errors.link ? 'has-error' : '',
                                ]"
                            >
                                <label for="file">Excel File</label>
                                <input
                                    class="form-control"
                                    id="file"
                                    type="file"
                                    ref="file"
                                    name="link"
                                    placeholder="Upload Excel"
                                    @change="addFile"
                                />
                                <span
                                    v-if="errors.link"
                                    :class="['badge bg-danger']"
                                    >Please add an excel file.</span
                                >
                            </div>
                        </div>
                        <button
                            class="btn btn-sm btn-primary"
                            @click="uploadPMFile"
                        >
                            Submit
                        </button>
                        <div class="card-footer">
                            <button
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="viewModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Branch Details</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            {{ employee }}
                        </div>
                        <div class="modal-footer">
                            <button
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <loading :show="lshow" :label="llabel"> </loading>
            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin() && !$gate.isHRAdmin()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
import Datatable from "../../datatable.vue";
import Pagination from "../../pagination.vue";
import { saveAs } from "file-saver";
import loading from "vue-full-loading";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { datatable: Datatable, pagination: Pagination, loading },

    created() {
        this.getEmployees();
        this.getCompanies();
        this.getBranches();
    },

    data() {
        let columns = [
            { width: "8%", label: "Code", name: "emp_code" },
            { width: "6%", label: "SAP-ID", name: "erp_emp_code" },
            { width: "6%", label: "SP-Code", name: "sp_code" },
            { width: "20%", label: "Name", name: "name" },
            { width: "20%", label: "Branch", name: "branch" },
            { width: "13%", label: "Phone", name: "phone" },
            { width: "9%", label: "Status", name: "status" },
            { width: "18%", label: "View More", name: "ops" },
        ];

        return {
            columns: columns,
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
            employees: [],
            branches: [],
            companies: [],
            params: new Form({
                name: null,
                phone: null,
                company: null,
                branch: null,
                brand: null,
                zone: null,
                emp_code: null,
                erp_emp_code: null,
                sp_code: null,
                results: null,
            }),
            branch: "",
            name: "",
            category: "",
            employee: "",
            lshow: false,
            llabel: "Syncing. Do not close or change this page...",
            file: "",
            link: "",
            errors: [],
            total_employees: "",
            total_results: "",
            total_oxy: "",
            total_ssq: "",
            total_ozn: "",
        };
    },

    methods: {
        syncSalesmen() {
            toast.fire({
                icon: "warning",
                title: "Wait For Syncing to be Over",
            });
            this.lshow = true;
            axios
                .post("/api/syncSAPEmployees")
                .then((response) => {
                    console.log(response); // Log the full response
                    if (
                        response.data &&
                        response.data.message === "Synchronization Successful"
                    ) {
                        toast.fire({
                            icon: "success",
                            title: `Synced ${response.data.count} entries`,
                        });
                        this.getEmployees();
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Syncing Failed!",
                        });
                    }
                    this.lshow = false;
                })
                .catch((error) => {
                    console.error(error); // Log any errors
                    toast.fire({
                        icon: "error",
                        title: "Syncing Failed!",
                    });
                    this.lshow = false;
                });
        },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        getEmployees(url = "/api/getSAPEmployees") {
            axios
                .post(url, { results: this.results, params: this.params })
                .then((response) => {
                    this.employees = response.data.data.data;
                    this.total_employees = response.data.total_employees;
                    this.total_results = response.data.total;
                    this.total_oxy = response.data.total_oxy;
                    this.total_ssq = response.data.total_ssq;
                    this.total_ozn = response.data.total_ozn;
                    this.configPagination(response.data.data);
                });
        },

        view(man) {
            this.employee = man;
            $("#viewModal").modal("show");
        },

        viewEmployeeProfile(emp) {
            window.open("/employee/profile/view/" + emp.id, "_blank");
        },

        Eexport(template) {
            axios({
                url: "/api/MEExport",
                data: { template: template },
                method: "post",
                responseType: "blob",
            }).then((response) => {
                toast.fire({
                    icon: "success",
                    title: "Report Generated",
                });
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(response.data, "employees.xlsx");
            });
        },

        uploadPrompt() {
            $("#uploadModal").modal("show");
        },

        addFile() {
            this.file = this.$refs.file.files[0];
            this.link = this.file;
        },

        uploadPMFile() {
            var formData = new FormData();
            formData.append("file", this.link);
            toast.fire({
                icon: "warning",
                title: "Wait For Syncing to be Over",
            });
            this.lshow = true;
            axios({
                method: "post",
                url: "/api/MEImport",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
            })
                .then(() => {
                    toast.fire({
                        type: "success",
                        title: "Syncing Success",
                    });
                    this.errors = [];
                    this.lshow = false;
                    this.getEmployees();
                })
                .catch((error) => {
                    this.lshow = false;
                    toast.fire({
                        type: "error",
                        title: "Syncing Failed",
                    });
                    console.log(error);
                    this.errors = error.response.data.errors;
                });
        },

        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getCompanies() {
            axios.post("/api/getCompanies").then((response) => {
                this.companies = response.data;
            });
        },

        reset() {
            this.params.name = null;
            this.params.phone = null;
            this.params.branch = null;
            this.params.company = null;
            this.params.results = null;
            this.params.erp_emp_code = null;
            this.params.emp_code = null;
            this.params.sp_code = null;
            this.params.brand = null;
            this.getEmployees();
            this.getCompanies();
            this.getBranches();
        },

        excel() {
            axios({
                url: "/api/salesmenExcel",
                data: { branch: this.branch, searchName: this.name },
                method: "post",
                responseType: "blob",
            }).then((response) => {
                toast.fire({
                    icon: "success",
                    title: "Report Generated",
                });
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                if (this.branch != "")
                    saveAs(response.data, "salesmen_" + this.branch + ".xlsx");
                else saveAs(response.data, "salesmen.xlsx");
            });
        },
    },
};
</script>
